import type { WorkspaceResponseV2 } from '@emma/api_client/types';
import { useMemo } from 'react';
import { useVulnerabilities } from '@/hooks/vulnerabilities';
import { paths } from '@/utility/global_paths';
import { getVulnerabilityTableColumns } from '../common/table/column_definitions/Vulnerabilities';
import { TableStoreProvider } from '../common/table/store/Context';
import { Table } from '../common/table/Table';

type Props = {
  workspace: WorkspaceResponseV2;
};

const vulnerabilitiesDescription =
  'Vulnerabilities on fleets. Click each row to inspect the vulnerabilities.';

export const VulnerabilitiesTable = (props: Props) => {
  const { data, isLoading, mutate, isValidating } = useVulnerabilities({
    workspaceId: props.workspace.id,
  });
  const vulnerabilityTableColumns = useMemo(
    () => getVulnerabilityTableColumns(props.workspace.id),
    [props.workspace.id]
  );

  return (
    <TableStoreProvider name="WorkspaceVulnerabilities">
      <Table
        columns={vulnerabilityTableColumns}
        count={data?.itemCount || 0}
        data={data?.vulnerabilities || []}
        description={vulnerabilitiesDescription}
        emptyMessage={data ? 'No vulnerabilities found' : undefined}
        filteredEmptyMessage="No vulnerabilities match the filters"
        isLoading={Boolean(isLoading || !data)}
        isValidating={isValidating}
        refresh={mutate}
        rowLink={({ repositoryId, workspaceId, tag }) =>
          repositoryId ? paths.imageTagById(workspaceId, repositoryId, tag) : ''
        }
        title="Vulnerabilities"
      />
    </TableStoreProvider>
  );
};
